import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// Define which routes require authentication
// Exported for utils/__tests__/everyRouteIsAnAccountPageOrAPublicOne.test.js:
// a page this gate protects must also be an account page for the API client.
export const PROTECTED_ROUTES = [
  '/home',
  '/profile',
  '/orders',
  '/appointments',
  '/booking',
  '/salon-details'
];

// Define which routes should redirect to home if user is already logged in
const AUTH_ROUTES = [
  '/login',
  '/register',
  '/'  // Root path should redirect to home if logged in
];

// Onboarding route: requires authToken (onboarding token) but not full customer in localStorage
const ONBOARDING_ROUTE = '/customer-onboard';

const AuthProtection = ({ children }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  // Check authentication state (support both authToken and accessToken from server)
  const customerData = localStorage.getItem("customer");
  const authToken = localStorage.getItem("authToken") || localStorage.getItem("accessToken");
  const isAuthenticated = Boolean(customerData && authToken);
  const hasOnboardingToken = Boolean(authToken && (currentPath === ONBOARDING_ROUTE));

  // Customer onboarding: allow if token present; redirect to login if no token
  if (currentPath === ONBOARDING_ROUTE) {
    if (!authToken) return <Navigate to="/login" state={{ from: currentPath }} replace />;
    if (isAuthenticated) return <Navigate to="/home" replace />;
    return children;
  }

  // Handle auth routes (redirect to home if already logged in)
  if (AUTH_ROUTES.some(route => currentPath === route || currentPath.startsWith(route + '/'))) {
    if (isAuthenticated) {
      // Redirect to home if trying to access login/register or root while authenticated
      return <Navigate to="/home" replace />;
    }
  }

  // Handle protected routes (require authentication)
  if (PROTECTED_ROUTES.some(route => currentPath === route || currentPath.startsWith(route + '/'))) {
    if (!isAuthenticated) {
      // Redirect to login if trying to access protected route without authentication
      return <Navigate to="/login" state={{ from: currentPath }} replace />;
    }
  }

  // If no special handling is needed, render the children
  return children;
};

export default AuthProtection; 